import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import './Services/GlobalVariables.js'
import { Storage } from './Services/Storage'
import DrawerLayout from 'vue-drawer-layout'
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import './registerServiceWorker'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

// Capture "Unexpected app closing" notification on tab close/background
let __userCreated = 'Unknown';
(async () => {
  try {
    const user = await Storage.getCurrentUser();
    __userCreated = (user && (user.Name || user.Username || user.name || user.username)) || 'Unknown';
  } catch (e) {
    __userCreated = 'Unknown';
  }
})();

function captureNotificationOnClose({
  eventtype = 'Checkout',
  description = 'Unexpected app closing',
  severity = 'Warning',
  usercreated = __userCreated,
} = {}) {
  try {
    const url = (window.wareHouseTomcatApi || '') + 'notifications/capture';
    const payload = { eventtype, description, severity, usercreated };
    const body = JSON.stringify(payload);

    // Preferred: navigator.sendBeacon with JSON Blob
    try {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) {
        return; // queued successfully
      }
    } catch (_) { /* fall back */ }

    // Fallback: fetch with keepalive (best-effort)
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
        credentials: 'include',
      }).catch(() => {});
    } catch (_) { /* swallow */ }
  } catch (_) { /* swallow outer */ }
}

let __captureFired = false;
function fireCaptureOnce(reasonText) {
  if (__captureFired) return;
  __captureFired = true;
  captureNotificationOnClose({
    eventtype: 'Checkout',
    description: reasonText || 'Unexpected app closing',
    severity: 'Warning',
    usercreated: __userCreated,
  });
}

// Register global handlers
window.addEventListener('beforeunload', () => {
  fireCaptureOnce('Unexpected app closing');
});

// Extra coverage for mobile/iOS where beforeunload may not fire reliably
window.addEventListener('pagehide', () => {
  fireCaptureOnce('App moved to background or page hidden');
});
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    fireCaptureOnce('App moved to background or page hidden');
  }
});

Vue.component('v-select', vSelect)
Vue.component('loading', Loading);
Vue.use(DrawerLayout);
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
